import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2";

const ItemData = [
  {
    img: "icon03",
    display: "咖啡豆",
    postion: "top",
    path: "商品類別-咖啡豆"
  },
  {
    img: "icon04",
    display: "濾掛盒",
    postion: "top",
    path: "商品類別-濾掛盒"
  },
  {
    img: "icon05",
    display: "單包濾掛",
    postion: "top",
    path: "商品類別-單包濾掛"
  },
  {
    img: "icon06",
    display: "咖啡禮盒",
    postion: "bottom",
    path: "商品類別-咖啡禮盒"
  },
  {
    img: "icon07",
    display: "咖啡濾紙",
    postion: "bottom",
    path: "商品類別-咖啡濾紙"
  },
  {
    img: "icon08",
    display: "沖煮設備",
    postion: "bottom",
    path: "商品類別-沖煮設備"
  },
  {
    img: "icon09",
    display: "濾杯器皿",
    postion: "bottom",
    path: "商品類別-濾杯器皿"
  }
];

class HecafePromotionSection extends Component {
  render() {
    let { navActions } = this.props;
    return (
      <Wrapper>
        <Widget.SectionTitle haveMarginBottom={true}>
          好咖類別
        </Widget.SectionTitle>
        <Widget.MaxWidth width={1035} css="width: 100%;">
          <Widget.Row justify="center" css="width: 100%;" wrap={"true"}>
            {ItemData.filter(data => data.postion === "top").map((data, i) => (
              <Item
                key={"top-item" + i}
                onClick={() => navActions.push(`/products/${data.path}`)}
                css={`
                  margin: 30px;
                  margin-right: 45px;
                  @media screen and (max-width: 550px) {
                    margin: 20px;
                  }
                `}
              >
                <img src={`/images/pages/landing/${data.img}.png`} />
                <div>{data.display}</div>
              </Item>
            ))}
          </Widget.Row>
          <Widget.Row justify="center" css="width: 100%;" wrap={"true"}>
            {ItemData.filter(data => data.postion === "bottom").map(
              (data, i) => (
                <Item
                  key={"bottom-item" + i}
                  onClick={() => navActions.push(`/products/${data.path}`)}
                  css={`
                    margin: 30px;
                    margin-right: 45px;
                    @media screen and (max-width: 550px) {
                      margin: 20px;
                    }
                  `}
                >
                  <img src={`/images/pages/landing/${data.img}.png`} />
                  <div>{data.display}</div>
                </Item>
              )
            )}
            <FakeItem
              css={`
                margin: 30px;
                margin-right: 45px;
                @media screen and (max-width: 550px) {
                  margin: 0px;
                }
              `}
            />
            <FakeItem
              css={`
                margin: 30px;
                margin-right: 45px;
                @media screen and (max-width: 550px) {
                  margin: 0px;
                }
              `}
            />
          </Widget.Row>
        </Widget.MaxWidth>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;

  ${props => props.css || ""};
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 15px;

  & > img {
    margin-bottom: 15.2px;
    width: 100px;
    height: 100px;
  }

  & > div {
    letter-spacing: 0.63px;
    font-size: 22px;
    color: #4e4e4e;
  }

  :hover {
    border-radius: 10px;
    background-color: #f0f0f0;
  }

  :active {
    position: relative;
    top: 1px;
    left: 1px;
  }

  @media screen and (max-width: 600px) {
    & > img {
      width: 82px;
      height: 82px;
    }
  }

  @media screen and (max-width: 550px) {
    & > img {
      width: 80px;
      height: 80px;
    }

    & > div {
      font-size: 14px;
    }
  }

  ${props => props.css || ""};
`;

const FakeItem = styled.div`
  width: 100px;

  @media screen and (min-width: 760px) {
    display: none;
  }

  @media screen and (max-width: 550px) {
    width: 0px;
    height: 0px;
  }

  ${props => props.css || ""};
`;

export default connect(
  null,
  ActionCreator
)(HecafePromotionSection);
